<template>
  <div class="sidebar-wrapper d-flex justify-content-between flex-column flex-grow-1">
    <div class="p-2">
      <b-button
        v-permission="'schedule_events.create'"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        aria-controls="sidebar-add-new-event"
        :aria-expanded="String(isEventHandlerSidebarActive)"
        variant="primary"
        block
        @click="$emit('update:isEventHandlerSidebarActive', true)"
      >
        Adicionar Evento
      </b-button>
      <div class="mt-3" :key="key">
        <h5 class="app-label section-label mb-1">
          <span class="align-middle">Calendários</span>
        </h5>
        <b-form-checkbox
          v-model="checkAll"
          class="mb-1"
        >
          Visualizar todos
        </b-form-checkbox>
        <b-form-group>
          <b-form-checkbox-group
            v-model="selectedCalendars"
            name="event-filter"
            stacked
          >
            <b-form-checkbox
              v-for="item in calendarTypes"
              :key="item.name"
              name="event-filter"
              :value="item.id"
              class="mb-1"
            >
              <span :style="`color: ${item.color}`">{{ item.name }}</span>
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
      <div class="mt-3" :key="key">
        <h5 class="app-label section-label mb-1">
          <span class="align-middle">Responsável</span>
        </h5>
        <div class="flex flex-row gap-0 items-center">
          <div class="__author-select">
            <vs-select autocomplete v-model="schedule_author" :options="scheduleAuthors">
              <vs-select-item
                v-for="(item,index) in scheduleAuthors"
                :key="index"
                :value="item.value"
                :text="item.text"
              />
            </vs-select>
          </div>
          <!-- <b-form-select v-model="schedule_author" :options="scheduleAuthors"></b-form-select> -->
          <b-icon-x
            class="text-red-light hover:text-red cursor-pointer"
            font-scale="2"
            @click="schedule_author = null"
            v-if="schedule_author"
          />
        </div>
      </div>
    </div>
    <b-img :src="require('@/assets/images/pages/calendar-illustration.png')" />
  </div>
</template>

<script>
import {
  BButton, BFormGroup, BFormCheckboxGroup, BFormCheckbox, BImg, BFormSelect, BIconX
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import useCalendarSidebar from './useCalendarSidebar'
import store from '@/store/store'

import CalendarTypeService from '@/services/api/CalendarTypeService'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BImg,
    BFormCheckbox,
    BFormGroup,
    BFormCheckboxGroup,
    BFormSelect,
    BIconX,
  },
  props: {
    isEventHandlerSidebarActive: {
      type: Boolean,
      require: true,
    },
    scheduleAuthors: {
      type: Array,
      require: false,
      default: () => []
    }
  },
  data: () => ({
    key: 0,
    calendarTypes: [],
    schedule_author: null
  }),
  watch: {
    '$store.state.calendar.calendarTypes'(val) {
      this.calendarTypes = val
      this.key++
      this.checkAll = true
    },
    schedule_author(val) {
      // Atualizar o store com o autor selecionado
      // O refetch será disparado automaticamente pelo watch no useCalendar.js
      this.$store.commit('calendar/SET_AUTHOR', val)

      // Manter o emit para compatibilidade com SchedulesForm.vue (se necessário)
      // mas remover o refetch duplo de lá
      this.$emit('filter:author', val)
    },
    // Sincronizar com o store quando o autor for alterado externamente
    '$store.state.calendar.selectedAuthor'(val) {
      if (this.schedule_author !== val) {
        this.schedule_author = val
      }
    }
  },
  setup() {
    const {
      selectedCalendars,
      checkAll,
    } = useCalendarSidebar()

    const service = CalendarTypeService.build(null)
    service.all().then(data => {
      store.commit('calendar/SET_CALENDAR_TYPES', data)
    })

    return {
      selectedCalendars,
      checkAll,
    }
  },
}
</script>

<style lang="scss">

// .sidebar-wrapper {
//   & .__author-select {
//     width: 100%;
//     max-width: 15rem;
//     z-index: 65000;

//     & .vs__selected-options {
//       max-width: 15rem;
//     }
//   }
// }

</style>
